import { gateway } from "../../../gateway";

export interface ISendAdminInvitePayload {
  email: string;
  target?: string;
}

export const sendUserInvitation = async ({ email, target = "admin" }: ISendAdminInvitePayload) => {
  try {
    const token = sessionStorage.getItem("token");
    if (!token) throw new Error("Missing auth token");

    const response = await gateway.post(
      "/invitations/",
      {
        target,
        email: email.trim().toLowerCase(),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data?.data;
  } catch (error) {
    console.error("Error sending admin invitation", error);
    throw error;
  }
};
